exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".team-member {\n  margin-bottom: 50px;\n  margin-left: 15px;\n  margin-right: 15px;\n  padding-top: 15px;\n  padding-bottom: 15px;\n  text-align: center;\n  border-radius: 10% 10%;\n  box-shadow: 0px 0px 30px 3px grey;\n  transition: 0.8s box-shadow; }\n  @media (max-width: 575px) {\n    .team-member {\n      border-radius: 0px;\n      box-shadow: none; } }\n  .team-member:hover {\n    box-shadow: 0px 0px 50px 10px #49c466; }\n    .team-member:hover img {\n      box-shadow: 0px 0px 30px 3px #49c466; }\n  .team-member img {\n    max-width: 225px;\n    max-height: 225px;\n    box-shadow: 0px 0px 20px 1px grey;\n    transition: 0.8s box-shadow; }\n    @media (max-width: 575px) {\n      .team-member img {\n        max-width: 175px;\n        max-height: 175px; } }\n  .team-member h4 {\n    margin-top: 25px;\n    margin-bottom: 0;\n    text-transform: none; }\n  .team-member p {\n    margin-top: 0; }\n  .team-member a {\n    color: white;\n    text-decoration: none;\n    cursor: default; }\n  .team-member a[href] {\n    cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Projects/dod/companyintroduction/src/app/team/member-card/member-card.component.scss
// module id = ../../../../../src/app/team/member-card/member-card.component.scss
// module chunks = main